import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import apiClient from '../../api/client';
import { toast } from 'sonner';
import { Dumbbell } from 'lucide-react';

const MemberLogin = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const [formData, setFormData] = useState({ phone: '', pin: '' });
  const [loading, setLoading] = useState(false);

  // 이미 로그인된 상태면 홈으로 즉시 이동 (자동 로그인 유지)
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/app/home', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const normalizedPhone = formData.phone.replace(/[^0-9]/g, '');
      
      const response = await apiClient.post('/app/auth/login', {
        phone: normalizedPhone,
        pin: formData.pin
      });
      
      login(response.data.token, response.data.member, response.data.is_default_pin);
      toast.success('로그인 성공!');
      navigate('/app/home');
    } catch (error) {
      console.error('Login failed:', error);
      toast.error('전화번호 또는 PIN이 올바르지 않습니다');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[#0F1115] p-5">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#FF7A00] to-[#FF8C42] rounded-2xl mb-5">
            <Dumbbell className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">Insight Fit</h1>
          <p className="text-[#52525B] text-sm mt-2">전화번호와 PIN으로 로그인하세요</p>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-[#A1A1AA] text-xs mb-2 ml-1">전화번호</label>
            <input
              type="tel"
              placeholder="01012345678"
              value={formData.phone}
              onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
              required
              data-testid="login-phone"
              className="w-full bg-[#1A1D23] border border-[#2A2E38] rounded-xl px-4 py-3.5 text-white placeholder-[#52525B] focus:outline-none focus:border-[#FF7A00]/50 focus:ring-1 focus:ring-[#FF7A00]/30 transition-colors"
            />
          </div>
          <div>
            <label className="block text-[#A1A1AA] text-xs mb-2 ml-1">PIN (4자리)</label>
            <input
              type="password"
              placeholder="****"
              maxLength="4"
              value={formData.pin}
              onChange={(e) => setFormData({ ...formData, pin: e.target.value })}
              required
              data-testid="login-pin"
              className="w-full bg-[#1A1D23] border border-[#2A2E38] rounded-xl px-4 py-3.5 text-white placeholder-[#52525B] text-center text-lg tracking-[0.5em] focus:outline-none focus:border-[#FF7A00]/50 focus:ring-1 focus:ring-[#FF7A00]/30 transition-colors"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-gradient-to-r from-[#FF7A00] to-[#FF8C42] text-white font-semibold py-3.5 rounded-xl hover:brightness-110 active:scale-[0.98] disabled:opacity-50 disabled:active:scale-100 transition-all duration-200 mt-2"
          >
            {loading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        {/* Info */}
        <div className="mt-8 bg-[#1A1D23] border border-[#22252E] rounded-xl p-4">
          <p className="text-sm text-[#A1A1AA] font-medium mb-2">로그인 안내</p>
          <p className="text-xs text-[#71717A]">• 전화번호: 숫자만 입력 (하이픈 없이)</p>
          <p className="text-xs text-[#71717A]">• 기본 PIN: 휴대폰번호 뒷자리 4자리</p>
          <p className="text-xs text-[#52525B] mt-2">예: 01012345678 → PIN: 5678</p>
        </div>
      </div>
    </div>
  );
};

export default MemberLogin;
